// Quita <script> y atributos on* antes de inyectar HTML con dangerouslySetInnerHTML.
export const sanitizeForInnerHTML = (html = "") =>
  html
    .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
    .replace(/\son\w+="[^"]*"/gi, "")
    .replace(/\son\w+='[^']*'/gi, "");
